import { BaseModel } from '@Core';

export enum TimeMode {
    NTP,
    Computer,
    Manual,
    GPS
}

export enum DayLight {
    Disabled,
    Automatic
}

export enum NTPSyncEnable {
    Disable,
    Enable
}
export interface PMC8266SysDateTime extends BaseModel {
    TimeZoneTz: string;
    DayLight: DayLight;
    TimeType: TimeMode;
    NtpServer: string;
    NtpSyncEnable: NTPSyncEnable;
    NtpInterval: number;
}